import { Box, Typography, Stack } from "@mui/material";
import { useDateTime } from "hooks";

export const TextingMessageBubble = ({ message, isSender, dateSent }) => {
  const formatDateTime = useDateTime();

  return (
    <Stack direction="column" alignItems={isSender ? "flex-end" : "flex-start"} sx={{ width: "100%", mb: 0.5 }}>
      <Box
        sx={{
          maxWidth: "70%",
        }}
      >
        <Box
          sx={{
            padding: "8px 12px",
            fontSize: "15px",
            lineHeight: 1.3,
            borderRadius: "18px",
            wordWrap: "break-word",
            color: isSender ? "common.white" : "text.primary",
            bgcolor: isSender ? "primary.main" : "grey.200",
            boxShadow: 1,
            borderBottomRightRadius: isSender ? "4px" : "18px",
            borderBottomLeftRadius: isSender ? "18px" : "4px",
          }}
        >
          {message}
        </Box>
      </Box>
      <Typography
        variant="caption"
        sx={{
          fontSize: "11px",
          color: "text.secondary",
          mt: 0.25,
          ml: isSender ? 0 : 1,
          mr: isSender ? 1 : 0,
        }}
      >
        {formatDateTime(dateSent)}
      </Typography>
    </Stack>
  );
};
